<template>
  <div class="form-group form-group-autocomplete" :class="{ '-open': show }">
    <TextInput :identifier="identifier"
               :placeholder="placeholder"
               :value="value"
               @update="$emit('update', $event)"
               @focusin="show = true"
               @input="show = true"
               @focusout="show = false"/>
    <Autocomplete
        @focusin="show = true"
        @focusout="show = false"
        :model="value"
        :filter="identifier"
        @update="show = false; $emit('update', $event)"/>
  </div>
</template>

<script>
// import { ref } from 'vue';
import TextInput from '@/components/Input/TextInput.vue';
import Autocomplete from '@/components/Autocomplete.vue';

export default {
  name: 'AutocompleteInput',
  components: { TextInput, Autocomplete },
  props: {
    identifier: String,
    placeholder: String,
    value: String,
  },
  data() {
    return {
      show: false,
    };
  },
};
</script>
